(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseScheduleDate(value) {
      if (!value) return NaN;
      var normalized = String(value).trim();
      var dateMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})[.\sT](\d{1,2})(?::|\.|h)?(\d{2})?$/i);
      if (dateMatch) {
        var hour = dateMatch[2].padStart(2, '0');
        var minute = (dateMatch[3] || '00').padStart(2, '0');
        normalized = dateMatch[1] + 'T' + hour + ':' + minute + ':00';
      }
      return new Date(normalized).getTime();
    }

    function isWithinSchedule(startValue, endValue) {
      var now = Date.now();
      var startTs = parseScheduleDate(startValue);
      var endTs = parseScheduleDate(endValue);
      if (!isNaN(startTs) && now < startTs) return false;
      if (!isNaN(endTs) && now >= endTs) return false;
      return true;
    }

    var SCHEDULE_HIDE_MS = 550;

    function getScheduleShell(el) {
      return el.closest('.shopify-section') || el;
    }

    function openScheduleSection(shell) {
      if (!shell) return;
      shell.classList.remove('is-schedule-closing', 'is-schedule-hidden');
      shell.style.height = '';
      shell.style.overflow = '';
    }

    function closeScheduleSection(shell, onDone) {
      if (!shell) return;
      if (shell.classList.contains('is-schedule-hidden') || shell.classList.contains('is-schedule-closing')) {
        return;
      }

      var currentHeight = shell.offsetHeight;
      shell.style.height = currentHeight + 'px';
      shell.style.overflow = 'hidden';
      void shell.offsetHeight;
      shell.classList.add('is-schedule-closing');

      setTimeout(function () {
        shell.classList.remove('is-schedule-closing');
        shell.classList.add('is-schedule-hidden');
        shell.style.height = '';
        shell.style.overflow = '';
        if (typeof onDone === 'function') onDone();
      }, SCHEDULE_HIDE_MS);
    }

    function applyHeroSchedule(slider) {
      if (!slider) return 0;
      var track = slider.querySelector('.hero-slider__track');
      var holder = slider.querySelector('[data-schedule-holder]');
      if (!track || !holder) return 0;

      var slides = Array.prototype.slice.call(
        slider.querySelectorAll('.hero-slider__slide[data-schedule-item]')
      );
      var visibleCount = 0;

      slides.forEach(function (slide) {
        var visible = isWithinSchedule(slide.dataset.scheduleStart, slide.dataset.scheduleEnd);
        slide.classList.toggle('is-schedule-hidden', !visible);
        if (visible) {
          track.appendChild(slide);
          visibleCount += 1;
        } else {
          holder.appendChild(slide);
        }
      });

      return visibleCount;
    }

    function syncHeroSectionVisibility(slider, visibleCount) {
      var shell = getScheduleShell(slider);
      if (visibleCount === 0) {
        if (slider.dataset.scheduleReady !== 'true') {
          shell.classList.add('is-schedule-hidden');
          destroyHeroSwiper(slider);
        } else {
          closeScheduleSection(shell, function () {
            destroyHeroSwiper(slider);
          });
        }
      } else {
        openScheduleSection(shell);
      }
      slider.dataset.scheduleReady = 'true';
    }

    function destroyHeroSwiper(slider) {
      if (slider.swiper && typeof slider.swiper.destroy === 'function') {
        slider.swiper.destroy(true, true);
      }
      slider.dataset.heroInitialized = 'false';
    }

    function initHeroSlider(slider) {
      if (!slider) return;

      var visibleCount = applyHeroSchedule(slider);
      syncHeroSectionVisibility(slider, visibleCount);
      if (visibleCount === 0) {
        return;
      }

      var track = slider.querySelector('.hero-slider__track');
      if (!track) return;

      var dotsWrap = slider.querySelector('.hero-slider__dots');
      var prevBtn = slider.querySelector('.hero-slider__arrow--prev');
      var nextBtn = slider.querySelector('.hero-slider__arrow--next');
      var progressFill = slider.querySelector('.hero-slider__progress-fill');
      var slides = Array.prototype.slice.call(
        track.querySelectorAll('.hero-slider__slide:not(.is-schedule-hidden)')
      );
      var total = slides.length;
      var autoplay = slider.dataset.autoplay === 'true';
      var delay = Math.max(parseInt(slider.dataset.delay, 10) || 3000, 3000);

      if (prevBtn) prevBtn.style.display = total > 1 ? '' : 'none';
      if (nextBtn) nextBtn.style.display = total > 1 ? '' : 'none';
      var progressBar = slider.querySelector('.hero-slider__progress-bar');
      if (progressBar) progressBar.style.display = total > 1 ? '' : 'none';

      if (total <= 1) {
        destroyHeroSwiper(slider);
        return;
      }

      if (slider.dataset.heroInitialized === 'true' && slider.swiper) {
        try {
          slider.swiper.update();
          slider.swiper.slideToLoop(0, 0);
        } catch (err) {}
        return;
      }

      slider.dataset.heroInitialized = 'true';

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.className = 'hero-slider__dot' + (i === 0 ? ' is-active' : '');
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.setAttribute('aria-selected', String(i === 0));
          dot.addEventListener('click', function () {
            if (slider.swiper) {
              slider.swiper.slideToLoop(i);
            }
          });
          dotsWrap.appendChild(dot);
        });
      }

      try {
        var swiper = new Swiper(slider, {
          loop: true,
          autoplay: autoplay
            ? {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          mousewheel: {
            forceToAxis: true,
          },
          on: {
            slideChange: function () {
              var dotIndex = this.realIndex;
              var dots = dotsWrap ? dotsWrap.querySelectorAll('.hero-slider__dot') : [];
              dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === dotIndex);
                dot.setAttribute('aria-selected', String(i === dotIndex));
              });

              if (progressFill) {
                var maxIndex = Math.max(total - 1, 1);
                var progress = Math.min(dotIndex / maxIndex, 1);
                progressFill.style.transform = 'translateX(' + 200 * progress + 'px)';
              }
            },
          },
        });
        slider.swiper = swiper;
      } catch (err) {
        console.error('Failed to initialize Swiper:', err);
      }
    }

    function refreshHeroSlider(slider) {
      if (!slider) return;
      if (slider.classList.contains('is-schedule-closing')) return;
      var shell = getScheduleShell(slider);
      if (shell.classList.contains('is-schedule-closing')) return;

      var before = slider.dataset.heroVisibleCount || '';
      var visibleCount = applyHeroSchedule(slider);
      var after = String(visibleCount);

      if (visibleCount === 0) {
        syncHeroSectionVisibility(slider, visibleCount);
        slider.dataset.heroVisibleCount = after;
        return;
      }

      syncHeroSectionVisibility(slider, visibleCount);
      if (before !== after) {
        destroyHeroSwiper(slider);
        slider.dataset.heroVisibleCount = after;
        initHeroSlider(slider);
      } else {
        slider.dataset.heroVisibleCount = after;
      }
    }

    function initAllHeroSliders(root) {
      var scope = root || document;
      scope.querySelectorAll('.hero-slider').forEach(function (slider) {
        slider.dataset.heroVisibleCount = '';
        destroyHeroSwiper(slider);
        initHeroSlider(slider);
        slider.dataset.heroVisibleCount = String(
          slider.querySelectorAll('.hero-slider__slide:not(.is-schedule-hidden)').length
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllHeroSliders(document);
      });
    } else {
      initAllHeroSliders(document);
    }

    setInterval(function () {
      document.querySelectorAll('.hero-slider[data-schedule-root]').forEach(refreshHeroSlider);
    }, 1000);

    document.addEventListener('shopify:section:load', function (event) {
      initAllHeroSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-tab-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiperInstances = {};

    function initTabSwipers(panelEl) {
      if (!panelEl || typeof Swiper === 'undefined') return;
      var swiperEls = panelEl.querySelectorAll('.mtc-swiper');
      if (!swiperEls || !swiperEls.length) return;

      swiperEls.forEach(function (el) {
        var swiperId = el.id;
        if (swiperInstances[swiperId]) {
          swiperInstances[swiperId].update();
          return;
        }

        swiperInstances[swiperId] = new Swiper(el, {
          slidesPerView: 2.2,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          mousewheel: {
            forceToAxis: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 2.2,
              spaceBetween: 12,
              slidesOffsetAfter: 16,
            },
            480: {
              slidesPerView: 2.2,
              spaceBetween: 16,
              slidesOffsetAfter: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
              slidesOffsetAfter: 0,
            },
            1000: {
              slidesPerView: 4.5,
              spaceBetween: 24,
              slidesOffsetAfter: 0,
            },
            1280: {
              slidesPerView: 4.5,
              spaceBetween: 24,
              slidesOffsetAfter: 0,
            },
          },
        });
      });
    }

    var sections = document.querySelectorAll('.mobile-tab-collections');

    sections.forEach(function (sec) {
      var tabBtns = sec.querySelectorAll('.mtc-nav__item');
      var panels = sec.querySelectorAll('.mtc-panel');

      // Init active panel on start
      var activePanel = sec.querySelector('.mtc-panel.is-active');
      if (activePanel) {
        initTabSwipers(activePanel);
      }

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-target');
          if (!targetId) return;

          // Toggle tab button states
          tabBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          // Scroll active tab into view in nav
          btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

          // Toggle tab panel visibility
          panels.forEach(function (p) {
            if (p.id === targetId) {
              p.classList.add('is-active');
              p.removeAttribute('hidden');
              // Initialize / update swipers for the newly active panel
              setTimeout(function () {
                initTabSwipers(p);
              }, 50);
            } else {
              p.classList.remove('is-active');
              p.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var unlockBtn = document.getElementById('password-unlock-btn');
    var popup = document.getElementById('password-popup');
    if (!unlockBtn || !popup) return;

    var overlay = popup.querySelector('.password-popup__overlay');
    var closeBtn = document.getElementById('password-popup-close');
    var input = document.getElementById('password-input');

    function openPopup() {
      popup.classList.add('is-open');
      popup.removeAttribute('aria-hidden');
      document.body.classList.add('password-popup-open');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('password-popup-open');
    }

    unlockBtn.addEventListener('click', openPopup);
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
